module.exports = "<ion-content>\n    <app-grid-speed [speedReport]='speed'></app-grid-speed>\n</ion-content>"